import { Controller } from 'react-hook-form'
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import { PropsValue, Select } from 'chakra-react-select'

import { useEventFormOptions } from '@hooks/useEventFormOptions'

import { MatchEventEditorEventType, MatchEventPeriodNumber } from '@common/types'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'

import { findOption, Option } from '../utils'

export function EventTypeSelect() {
    const { zodForm, isFormDisabled } = useMatchEditorFormContext()
    const { types, periods } = useEventFormOptions()

    if (!types.length) {
        return null
    }

    const onPenaltyMissedInShootoutSelected = () => {
        zodForm.setValue('period_number', findOption(MatchEventPeriodNumber.penalties.toString(), periods), {
            shouldValidate: true,
        })
    }

    const onPeriodEventSelected = () => {
        zodForm.setValue('team_id', undefined)

        zodForm.setValue('player1_id', undefined)

        zodForm.setValue('player2_id', undefined)
    }

    return (
        <Controller
            control={zodForm.control}
            name="type"
            render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { error } }) => (
                <FormControl isInvalid={!!error} isRequired mb={8} isDisabled={isFormDisabled}>
                    <FormLabel htmlFor="type">Select event type</FormLabel>
                    <Select
                        id="type"
                        isSearchable
                        name={name}
                        ref={ref}
                        onChange={e => {
                            zodForm.clearErrors()

                            zodForm.setValue('extra_info', undefined)

                            const selectedType = Number(e?.value)
                            if (selectedType === MatchEventEditorEventType.penalty_shootout_event_deep_coverage) {
                                onPenaltyMissedInShootoutSelected()
                            } else if (selectedType === MatchEventEditorEventType.fixture_status) {
                                onPeriodEventSelected()
                            }

                            onChange(e)
                        }}
                        onBlur={onBlur}
                        value={value as unknown as PropsValue<Option>}
                        placeholder="Select event type"
                        options={types}
                    />

                    <FormErrorMessage>{zodForm.formState.errors.type?.message}</FormErrorMessage>
                </FormControl>
            )}
        />
    )
}
